import React, { useState, useRef, useEffect, useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactDOM from 'react-dom'
import AutoCompleteList from '../layout/AutoCompleteList'
import { ContentInner } from '../layout/Content'
import { filterItemsSearch } from '../utilities/utilities'
import { findAndReplaceContext } from './FindAndReplaceController'

function FindAndReplaceInner() {
  const brandRef = useRef()
  const findAndReplace = useContext(findAndReplaceContext)
  const [activeInput, setActiveInput] = useState('')
  const [item, setItem] = findAndReplace.item
  const productsList = findAndReplace.products_list
  const [currentItemList, setCurrentItemList] = useState([])
  const [itemClicked, setItemClicked] = useState(false)
  const [keyPressed, setKeyPressed] = useState('')

  const onChange = (e) => {
    // If keyPressed is an unwanted character then return and ignore
    if (!keyPressed) return
    setActiveInput(e.target.id)
    const filteredItemList = filterItemsSearch(productsList.map(item => item[e.target.name]), e.target.value)
    setCurrentItemList(filteredItemList)
    setItem({ ...item, [e.target.id]: e.target.value })
  }

  const onKeyDown = (e) => {
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break;
      case 'Enter':
      case 'Tab':
      case 'Escape':
        setCurrentItemList([])
        ReactDOM.unmountComponentAtNode(document.getElementById(e.target.id+'-acl-container'))
        break
      default:
        setKeyPressed(e.key)
    }
   }

  const onClickFindAndReplace = () => { findAndReplace.findAndReplaceItems() }

  const onBlur = (e) => setActiveInput(e.target.id)

  const events = { onKeyDown: onKeyDown, onBlur: onBlur, onChange: onChange }

  useEffect(() => brandRef.current.focus(), [])

  useEffect(() => {
    if (activeInput) {
      if (currentItemList.length > 0)
        ReactDOM.render(
          <AutoCompleteList
            valueSetter={(value) => setItem({...item, [activeInput]: value})}
            keyPressed={keyPressed}
            setItemClicked={setItemClicked}
            items={currentItemList}
          />, document.getElementById(activeInput+'-acl-container')
        )
      else
        ReactDOM.unmountComponentAtNode(document.getElementById(activeInput+'-acl-container'))

      // clear keyPressed to renew it
      if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed('')

      if (itemClicked) {
        setCurrentItemList([])
        setItemClicked(false)
      }
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, keyPressed, itemClicked])

  return (
    <ContentInner>
      <div id='find-and-replace-container'>
        <div id='form-group-container'>
          {/* Brand */}
          <div className='form-group' id='brand-container'>
            <div>BRAND</div>
            <input name='brand' autoComplete='off' id='brand_from' type='text' placeholder='From' value={item.brand_from}
              ref={brandRef}
              {...events}
            />
            <div id='brand_from-acl-container' className='acl-container'></div>
            <input name='brand' autoComplete='off' id='brand_to' type='text' placeholder='To' value={item.brand_to}
              {...events}
            />
            <div id='brand_to-acl-container' className='acl-container'></div>
            <div id='brand-update-result-container' className='result-container'>
              <h5>{item.brand_message}</h5>
            </div>
          </div>

          {/* Name */}
          <div className='form-group' id='name-container'>
          <div>NAME</div>
            <input name='name' autoComplete='off' id='name_from' type='text' placeholder='From' value={item.name_from}
              {...events}
            />
            <div id='name_from-acl-container' className='acl-container'></div>
            <input name='name' autoComplete='off' id='name_to' type='text' placeholder='To' value={item.name_to}
              {...events}
            />
            <div id='name_to-acl-container' className='acl-container'></div>
            <div id='name-update-result-container' className='result-container'>
              <h5>{item.name_message}</h5>
            </div>
          </div>

          {/* Description */}
          <div className='form-group' id='description-container'>
            <div>DESCRIPTION</div>
            <input name='description' autoComplete='off' id='description_from' type='text' placeholder='From' value={item.description_from}
              {...events}
            />
            <div name='description' id='description_from-acl-container' className='acl-container'></div>
            <input name='description' autoComplete='off' id='description_to' type='text' placeholder='To' value={item.description_to}
              {...events}
            />
            <div id='description_to-acl-container' className='acl-container'></div>
            <div id='description-update-result-container' className='result-container'>
              <h5>{item.description_message}</h5>
            </div>
          </div>

          {/* Classification */}
          <div className='form-group' id='classification-container'>
          <div>Classification</div>
            <input name='classification' autoComplete='off' id='classification_from' type='text' placeholder='From' value={item.classification_from}
              {...events}
            />
            <div id='classification_from-acl-container' className='acl-container'></div>
            <input name='classification' autoComplete='off' id='classification_to' type='text' placeholder='To' value={item.classification_to}
              {...events}
            />
            <div id='classification_to-acl-container' className='acl-container'></div>
            <div id='classification-update-result-container' className='result-container'>
              <h5>{item.classification_message}</h5>
            </div>
          </div>
        </div>
        <hr />
        {/* Find and Replace button */}
        <div id='find-and-replace-button-container'>
          <button id="find-and-replace-btn" type='button' className='pospro-action-btn'
            onClick={onClickFindAndReplace}>
            <FontAwesomeIcon icon='edit'/>&nbsp;Go Find & Replace
          </button>
        </div>
      </div>
    </ContentInner>
  )
}

export default React.memo(FindAndReplaceInner)